export default function VoiceIcon({ className = "" }: { className?: string }) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.83834 2.27115C3.73908 3.17251 3.02324 4.45777 2.83566 5.86689L1.25916 8.34655C1.15546 8.5098 1.17648 8.75364 1.41611 8.85593L2.78941 9.44449V11.4967C2.78941 11.6808 2.82566 11.863 2.89608 12.033C2.96651 12.203 3.06973 12.3575 3.19985 12.4876C3.32998 12.6178 3.48446 12.721 3.65448 12.7914C3.8245 12.8618 4.00672 12.8981 4.19074 12.8981H5.59137L5.59184 14.2995C5.59197 14.6865 5.90568 15.0001 6.29262 15.0001C6.67965 15.0001 6.99341 14.6863 6.99341 14.2993V13.5987L6.99325 13.3637C6.99256 12.3324 6.15633 11.4967 5.12501 11.4967H4.19074V8.52031L3.10471 8.05507L4.18584 6.35596L4.22578 6.04626C4.36341 4.98681 4.89924 4.01949 5.7244 3.34088C6.54955 2.66226 7.60211 2.32326 8.66821 2.39276C9.73431 2.46226 10.734 2.93504 11.464 3.71503C12.1941 4.49503 12.5998 5.52372 12.5987 6.59208V7.292C12.5987 7.67897 12.9124 7.99267 13.2994 7.99267C13.6864 7.99267 14.0001 7.67897 14.0001 7.292V6.59208C13.9963 5.17053 13.4528 3.80347 12.4794 2.76748C11.5059 1.73149 10.1753 1.10394 8.75678 1.0118C7.33821 0.919655 5.93761 1.3698 4.83834 2.27115Z"
        fill="#667085"
      />
      <path
        d="M8.63208 11.0832V13.0453"
        stroke="#667085"
        strokeWidth="1.336"
        strokeLinecap="round"
      />
      <path
        d="M13.3032 11.0832V13.0453"
        stroke="#667085"
        strokeWidth="1.336"
        strokeLinecap="round"
      />
      <path
        d="M10.9672 10.0997L10.9672 14.0286"
        stroke="#667085"
        strokeWidth="1.336"
        strokeLinecap="round"
      />
    </svg>
  );
}

export const displayName = "VoiceIcon";
